<template>
  <div class="history" ref="school-form">
      <template>

        <v-form
          ref="customer-form"
          :value="customerValid"
          lazy-validation
        >
          <v-row>
            <v-col cols="12" class="mt-0 pt-0">

              <!-- お客様No. -->
              <v-row class="mx-6">
                <v-col cols="12" class="pt-0 pb-2">
                  <v-text-field
                    style="margin-top: 0px !important"
                    v-model="code"
                    label="お客様No."
                    :counter="9"
                    :rules="rules.clientCode"
                  >
                    <template #[`label`]>
                      お客様No. <font color="red">❇︎</font>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <!-- 塾名 -->
              <v-row class="mx-6">
                <v-col cols="12" class="pt-0 pb-2">
                  <v-textarea
                    v-model="name"
                    :counter="50"
                    label="塾名"
                    :rules="rules.customerName"
                    rows=2
                    no-resize
                  >
                    <template #[`label`]>
                      塾名 <font color="red">❇︎</font>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>

              <!-- 郵便番号 -->
              <!-- <v-row class="mx-6">
                <v-col cols="10" class="pt-0 pb-2">
                  <v-text-field
                    v-model="postCode"
                    :counter="7"
                    label="郵便番号"
                    :rules="rules.postCode"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2" class="pt-9 pb-2">
                  <v-btn
                    color="secondary"
                    x-small
                    :disabled="!postCode || !validPostCode"
                    @click="postalSearch">
                    検索
                  </v-btn>
                </v-col>
              </v-row> -->

              <!-- 住所 -->
              <v-row class="mx-6">
                <v-col cols="12" class="pt-0 pb-2">
                  <v-textarea
                    v-model="address"
                    :counter="100"
                    label="住所"
                    :rules="rules.address"
                    rows=2
                    no-resize
                  >
                    <template #[`label`]>
                      住所 <font color="red">❇︎</font>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>

              <!-- 電話番号 -->
              <v-row class="mx-6">
                <v-col cols="12" class="pt-0 pb-2">
                  <v-text-field
                    v-model="tel"
                    label="代表者電話番号"
                    :counter="11"
                    :rules="rules.tel"
                  >
                    <template #[`label`]>
                      電話番号 <font color="red">❇︎</font>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <!-- メールアドレス -->
              <v-row class="mx-6">
                <v-col cols="12" class="pt-0 pb-2">
                  <v-textarea
                    v-model="email"
                    label="メールアドレス"
                    :counter="100"
                    :rules="rules.mail"
                    rows=2
                    no-resize
                  >
                    <template #[`label`]>
                      メールアドレス <font color="red">❇︎</font>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>

              <!-- EN担当者名 -->
              <v-row class="mx-6">
                <v-col cols="12" class="pt-0 pb-2">
                  <v-text-field
                    v-model="representative"
                    label="EN担当者名"
                    :counter="20"
                    :rules="rules.representative"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- ロゴファイル -->
              <v-row>
                <v-col class="ml-1 pr-11 pt-0 pb-2" cols="12">
                  <v-file-input
                    accept="image/gif, image/jpg, image/jpeg, image/png"
                    label="ロゴファイル ※拡張子はgif .jpg .jpeg .pngのみ使用可能です。"
                    :show-size="!!logoImage"
                    :clearable="false"
                    color="secondary"
                    truncate-length="50"
                    v-model="logo"
                    @change="onChange"
                    @click:append-outer.stop="onClear"
                    :append-outer-icon="logo ? 'mdi-delete' : ''"
                    :rules="rules.logo"
                  ></v-file-input>
                  <div>
                    <v-img
                      v-if="logoImage"
                      class="ml-8"
                      style="display: inline-block"
                      contain
                      :src="logoImage"
                      max-height="165px"
                      max-width="165px"
                      position="top"/>
                    <v-btn
                      v-if="logoImage"
                      :disabled="!logoImage || !previewImage"
                      class="mb-4"
                      color="secondary"
                      small
                      @click.stop="showPhotoSwipe(0)"
                    >
                      ロゴ挿入イメージ
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <!-- 請求方法 -->
              <v-row class="mx-6">
                <v-col cols="12" class="pt-0 pb-2">
                  <p>請求方法<font color="red">❇︎</font><font size="1" class="ml-2">※請求方法を変更する場合は、毎月24日までに各教室の契約情報（日付）の値の変更が完了するようにコンバインへ依頼する</font></p>
                  <v-radio-group
                    v-model="billing"
                    class="radio-group"
                    hide-details
                    :rules="[v => !!v || '請求方法を選択してください']"
                    row
                  >
                    <v-radio
                      class="mb-2"
                      label="年間"
                      value="yearly_billing"
                      color="secondary"
                    ></v-radio>
                    <v-radio
                      class="mb-2"
                      label="月々"
                      value="monthly_billing"
                      color="secondary"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3" sm="3" md="2" />
          </v-row>
        </v-form>

        <template v-if="$store.state.school.id">
          <v-row>
            <v-col class="pt-0">
              <p class="mx-9 mt-4">登録済教室一覧</p>
              <v-btn
                style=""
                class="mt-4 mr-4 create-button"
                small
                color="#4a81aa"
                dark
                @click.stop="create"
                >新規作成
              </v-btn>
            </v-col>
          </v-row>
          <v-card class="mx-9 my-1">
            <v-data-table
              :headers="headers"
              :items="accounts"
              disable-pagination
              hide-default-footer
              mobile-breakpoint=10
            >
              <template #[`item`]="{ item }">
                <tr :style="item.useStatus === '利用不可' ? 'background: #bababa' : ''">
                  <td>{{item.users[0].login}}</td>
                  <td align="center">{{item.name}}</td>
                  <td align="center">{{item.useStatus}}</td>
                  <td align="center">{{item.agreementUpdateOn}}</td>
                  <td align="center">
                    <v-btn icon @click.stop="edit(item)">
                      <v-icon small dark>
                        mdi-cog-outline
                      </v-icon>
                    </v-btn>
                  </td>
                  <td align="center">
                    <v-btn icon @click.stop="openDeleteConfirmDialog(item)">
                      <v-icon dark>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </template>

        <v-btn class="mt-8 ml-8" color="secondary" dark @click.stop="submit">保存</v-btn>
        <v-btn class="mt-8 ml-5" color="gray" @click.stop="$router.push('/admin/schools')">塾一覧に戻る</v-btn>

      <v-confirm-dialog
        ref="confirm"
        :title="confirmDialogTitle"
        :message="deleteMessage"
        buttonMessage="削除"
        @confirm="confirmDeletion"
      />

      <v-photo-swipe
        :isOpen="isOpenPhotoSwipe"
        :items="[{ src: previewImage, w: 600, h: 900} ]"
        :options="photoswipeOptions"
        @close="hidePhotoSwipe" />
    </template>
  </div>
</template>

<script>
import rules from '../../rules'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'
import axiosJsonpAdapter from 'axios-jsonp'
import VPhotoSwipe from '@/components/atoms/PhotoSwipe'
import moment from 'moment'

const ZIPCODE_API_URL = 'http://zipcloud.ibsnet.co.jp/api/search'

export default {
  components: {
    VConfirmDialog,
    VPhotoSwipe
  },

  data () {
    return {
      headers: [
        { text: 'ログインID', align: 'start', value: 'users[0].login' },
        { text: '教室名', align: 'center', value: 'name', sortable: false },
        { text: '利用状況', align: 'center', value: 'useStatus', sortable: false },
        { text: '前回契約更新日', align: 'center', value: 'agreementUpdateOn', sortable: false },
        { text: '編集', align: 'center', value: 'edit', sortable: false },
        { text: '削除', align: 'center', value: 'delete', sortable: false },
      ],
      accounts: [],
      requests: [],
      deletedAccount: {},
      confirmDialogTitle: '',
      logoPreviewUrl: null,
      previeImage: '',
      clientWidth: 0,
      photoswipeOptions: {
        index: 0,
        closeOnScroll: false
      },
      isOpenPhotoSwipe: false,
      rules: rules,
      // 編集中の塾情報
      name: this.$store.state.school.name,
      code: this.$store.state.school.code,
      tel: this.$store.state.school.tel,
      email: this.$store.state.school.email,
      postCode: this.$store.state.school.postCode,
      address: this.$store.state.school.address,
      representative: this.$store.state.school.representative,
      billing: this.$store.state.school.billing,
      logo: this.$store.state.school.logo,
      logoImage: this.$store.state.school.logoImage,
    }
  },

  computed: {
    customerValid: {
      get() {
        return this.$store.state.school.customerValid
      },
      set(value) {
        this.$store.commit('school/setCustomerValid', {
          valid: value
        })
      }
    },
    deleteMessage() {
      const logoName = this.logo ? this.logo.name : ''
      return `${this.deletedAccount.name || logoName} を削除します。よろしいですか。`
    },
    previewImage() {
      if (!this.logoPreviewUrl) return ''
      return this.logoPreviewUrl
    },
    validPostCode() {
      const postCode = this.postCode
      let result = true
      this.rules.postCode.forEach((rule) => {
        if (rule(postCode) !== true) result = false
      })
      return result
    }
  },

  async mounted() {
    // リサイズ処理
    this.clientWidth = this.$el.clientWidth
    window.addEventListener('resize', this.resize)

    // 新規追加画面でリロードされた場合は初期化する
    if (!this.$store.state.school.id) this.$store.commit('school/initialize')

    // アカウント取得
    this.getAccounts()

    // ロゴ画像表示処理
    if (this.$store.state.school.logoUrl) {
      await this.$store.dispatch('school/getAttached', {
        filePath: this.$store.state.school.logoUrl,
        filename: this.$store.state.school.logoFilename,
      })
      this.logo = this.$store.state.school.logo,
      this.logoImage = this.$store.state.school.logoImage,
      this.onChange()
    } else {
      this.$store.commit('school/setLogoImage', { logoImage:  null })
    }

    await this.getSchoolApplies()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    resize() {
      this.clientWidth = this.$el.clientWidth
    },
    async submit() {
      const customerValid = this.$refs["customer-form"].validate()
      this.$store.commit('school/setCustomerValid', { valid: customerValid })
      if (!customerValid) {
        this.$toasted.global.error({ message: '塾情報に入力不備があります。' })
        return
      }

      this.$store.commit('school/setSchool', {
        name: this.name,
        code: this.code,
        tel: this.tel,
        email: this.email,
        postCode: this.postCode,
        address: this.address,
        representative: this.representative,
        billing: this.billing,
        logo: this.logo,
        logoImage: this.logoImage
      })

      this.$emit('submit')
    },
    //ロゴ画像用処理
    async onChange() {
      const reader = new FileReader()
      reader.readAsDataURL(this.logo)

      reader.onload = (e) => {
        this.logoImage = e.target.result
      }
      // ロゴ挿入イメージ作成
      let form = new FormData()
      form.append('logo', this.logo)
      const schoolId = this.$store.state.school.id
      const res = await this.$axios.post(`/api/v1/admin/customers/${schoolId ? schoolId : 3}/log_preview`, form)
      this.logoPreviewUrl = res.data.src
    },
    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')

      return fileName
    },
    async getSchoolApplies() {
      this.loading = true
      const res = await this.$axios('/api/v1/admin/customers/get_cancel_requests')
      this.requests = res.data
      this.loading = false
    },
    //ロゴ画像用処理
    onClear() {
      if(!this.logo) return
      this.confirmDialogTitle ='ロゴ削除'
      this.deletedAccount = {}
      this.previeImage = null
      this.$refs.confirm.open()
    },
    // 塾IDに紐付く教室一覧を取得
    async getAccounts() {
      const currentCustomerId = this.$store.state.school.id
      const res = await this.$axios.get('/api/v1/admin/branches?customer_id=' + currentCustomerId)
      this.accounts = res.data
    },
    async edit(account) {
      this.requests = this.requests.filter((request) =>
          request.branchesRequests[0] != undefined
      );

      if (this.requests.length === 0) {
        this.$store.commit('account/setAccount', account)
        this.$router.push('/admin/account/')
      } else {
        const target_value = []
        const other_value = []
        let ok_flg = false

        this.requests.map(function(request) {
          if (request.branchesRequests[0].branch.id === account.id){
            target_value.push(request)
            ok_flg = true
          } else {
            other_value.push(request)
          }
        })
        this.$store.commit('account/setStatus', {
          status: 'edit'
        })
        this.$store.commit('account/setAccount', account)
        this.$router.push('/admin/account/')
        if (ok_flg){
          await this.$store.commit('apply/setApply', target_value.slice(-1)[0])
        } else {
          other_value[0].id = null
          await this.$store.commit('apply/setApply', other_value[0])
        }
      }
    },
    create() {
      this.$store.commit('account/initialize')
      const defaultUseStartOn = moment().hour(0).minute(0).second(0).millisecond(0).format() //新規作成時は本日の0:00をデフォルト値として設定する
      this.$store.commit('account/setUseStartOn', {
        useStartOn: defaultUseStartOn
      })
      this.$store.commit('account/setStatus', {
        status: 'new'
      })
      this.$router.push('/admin/account')
    },
    // アカウント削除API
    openDeleteConfirmDialog(account) {
      this.confirmDialogTitle ='教室削除'
      this.deletedAccount = account
      this.$refs.confirm.open()
    },
    async confirmDeletion() {
      if (Object.keys(this.deletedAccount).length) {
        //教室削除
        const url = `api/v1/admin/branches/${this.deletedAccount.id}`
        await this.$axios.delete(url)
        this.$toasted.global.success({ message: `${this.deletedAccount.name} を削除しました` })
        this.getAccounts()
      } else {
        //ロゴ画像削除
        this.logo = null
        this.logoImage = null
        this.$store.commit('school/setLogoImage', { logoImage: null })
        this.$store.commit('school/setLogo', { logo: new File([], '', {}) })
      }
    },
    showPhotoSwipe(index) {
      this.isOpenPhotoSwipe = true
      this.$set(this.photoswipeOptions, 'index', index)
    },
    hidePhotoSwipe(){
      this.isOpenPhotoSwipe = false
    },
    async postalSearch() {
      const res = await this.$axios.get(ZIPCODE_API_URL, {
        adapter: axiosJsonpAdapter,
        params: {
          zipcode: this.postCode
        }
      })

      if (!res) {
        this.$toasted.global.error({ message: '郵便番号が正しくありません。' })
      } else if (!res.data.results){
        this.$toasted.global.error({ message: res.data.message || '郵便番号が正しくありません。' })
      } else {
        const data = res.data
        const result = data.results[0]
        const address =  result.address1 + result.address2 + result.address3
        this.address = address
      }
    },
  },
}
</script>

<style lang="stylus" scoped>

p
  margin-bottom 0px !important
  font-size 15px
  color #424242
  display inline-block

.select
  font-size 11px !important

.create-button
  display inline-block
  position absolute
  right 51px

.radio-group
  margin-top 5px !important
  border-bottom 1px solid #9e9e9e

.preview
  &-image
    position absolute
    top 60px
    right 100px

  &-title
    margin-bottom 5px !important

.grayRow
  background: #bababa

tr.grayRow:hover{
  background: #bababa !important
}
</style>
